import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Stack} from "@mui/material";
import {styled} from "@mui/material/styles";

import Badge from "components/Badge";
import completenessColor from "components/Product/Table/completenessColor";
import {greyishBlue400} from "assets/jss/main";
import {getScoreTheme} from "views/marketplace/retailer/product/utils/ScoreColorCalculator";

ScoringCell.propTypes = {
    completeness: PropTypes.number,
    score: PropTypes.number,
    potentialScore: PropTypes.number,
};

const Caption = styled('span')({
    color: greyishBlue400,
    fontSize: '12px',
});

function ScoringCell({completeness, score, potentialScore}) {
    const hasCompleteness = null !== completeness && undefined !== completeness;
    const hasScore = null !== score && undefined !== score;

    return (
        <Stack gap="8px" sx={{width: '104px'}}>
            {hasCompleteness && (
                <Stack gap="4px" alignItems="flex-start">
                    <Badge rounded color={completenessColor(completeness)} border>{`${completeness}`}</Badge>
                    <Caption><FormattedMessage id="enrichment.scoring.completeness"/></Caption>
                </Stack>
            )}
            {hasScore && (
                <Stack gap="4px" alignItems="flex-start">
                    <Badge rounded color={getScoreTheme(score).theme} border>
                        <FormattedMessage id="enrichment.scoring.score" values={{score, max: potentialScore ?? score}}/>
                    </Badge>
                    <Caption><FormattedMessage id="enrichment.scoring.scoreCaption"/></Caption>
                </Stack>
            )}
        </Stack>
    );
}

export default ScoringCell;
